export default "__VITE_ASSET__Cd8qGS$B__"